export const mobileMaxWidth = 600;
export const mobileDeviceQuery = `(max-width:${mobileMaxWidth}px)`;
export const mobileDevice = `@media ${mobileDeviceQuery}`;

export const getStyles = () => ({
  locationTargetErrorCallout: {
    width: '460px',
    paddingLeft: '30px',
    paddingRight: '20px',
    fontSize: '12px',

    '& .location-target-error-callout-details-list': {
      minWidth: '390px',

      '& .ms-DetailsRow': { background: '#fff' },

      '& .column-label': {
        color: '#323130',
        paddingLeft: 0,
      },

      '& .column-name-and-radius': {
        color: '#797775',
      },

      '& .column-remove': {
        paddingTop: '2px',
      },
    },
    [mobileDevice]: {
      width: 'auto',
    },
  },
});
